export default {
    wares:[],
    purchaseNum: [],
    successOrderList: [],
    msg: '',
    errList: [],
    hasErr: false,
    companyName: '', //公司名称
    taxpayerNumber: '', //税号
}


// WEBPACK FOOTER //
// ./src/store/confirm/state.js